import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Renderer2, ElementRef } from '@angular/core';
import { AlertService } from '../../../alert.service';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { MatDialog } from '@angular/material/dialog';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import { ComentarioSolicitarRevisionComponent } from 'src/app/modules/case/components/comentario-solicitar-revision/comentario-solicitar-revision.component';
import { RemitCaseComponent } from 'src/app/modules/cases/components/remit-case/remit-case.component';
import { GenerateTasksComponent } from 'src/app/modules/case/components/generate-tasks/generate-tasks.component';
import { ProceedCaseComponent } from 'src/app/modules/cases/components/proceed-case/proceed-case.component';
import { CreateAlertComponent } from 'src/app/modules/cases/components/create-case/create-alert/create-alert.component';
import { AlertRecordService } from '../../../alert-record.service';
import { first, map } from 'rxjs/operators';
import { AssignmentModalComponent } from '../header-case-tabs/assignment-modal/assignment-modal.component';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { CaseFileService } from 'src/app/modules/case/services/case-file.service';
import { CallContactService } from '../../../call-contact.service';
import { CaseCommentService } from 'src/app/modules/case/services/case-comment.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
export enum statusSkuld {
  initial = 'Sin asignar',
  running = 'En proceso',
  tobeApproved = 'Por aprobar',
  toFinalize = 'Finalizado',
  archived = 'Archivado',
  pending = 'Pendiente',
  assigned = 'Asignado',
  rejected = 'Rechazado',
  refused = 'Rechazado',
  finalized = 'Finalizado',
}

@Component({
  selector: 'stepper-skuld',
  templateUrl: './stepper-skuld.component.html',
  styleUrls: ['./stepper-skuld.component.scss'],
})
export class StepperSkuldComponent {
  encabezadoBase64: string = ''; // Variable para almacenar la imagen Base64
  isLoading: boolean = false; // Variable para controlar el loading
  @Input() alert: any;
  // @Input() case: any;
  // case declarado
  @Input() set case(value: any) {
    // console.log('Case recibido:', value);
    this._case = value;
  }
  get case() {
    return this._case;
  }
  @Output() proceedAlert = new EventEmitter<string>();

  private _case: any;
  @Input() allCallContact: any[] = []; // Recibimos los contactos
  @Input() filteredFiles: any[] = []; // Archivos filtrados
  @Input() grafoImageUrl: string = ''; // URL de la imagen del grafo
  @Input() skuld: boolean = false;
  @Output() headerMessage = new EventEmitter<any>();
  status = statusSkuld;
  statusNumber: number;
  newCase: any = {};
  // si tiene permiso para crearCasos
  hasCreateCasesPermission: boolean;
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private alertService: AlertService,
    private readonly dialog: MatDialog,
    private readonly caseService: CaseService,
    private readonly caseRecordService: CaseRecordService,
    private readonly casesService: CasesService,
    private readonly userService: UserService,
    private readonly alertRecordService: AlertRecordService,
    private readonly caseFilesService: CaseFileService,
    private readonly callContactService: CallContactService,
    private readonly caseCommentService: CaseCommentService,
    private readonly snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router,
  ) {}

  get needApproval() {
    if (!this.case) return false;
    const { approvalRoles } = this.case.caseType;
    const { approvalStatus } = this.case;
    const roleId = this.userService.currentUser?.role._id;
    if (
      approvalRoles?.levelOne == roleId &&
      approvalStatus == 'requestLevelOne'
    )
      return true;
    if (
      approvalRoles?.levelTwo == roleId &&
      approvalStatus == 'requestLevelTwo'
    )
      return true;
    return false;
  }

  get assignedApproval() {
    if (!this.case) return false;
    if (this.case.approvalUser == this.userService.currentUser?._id)
      return true;
    return false;
  }
  get canAssign() {
    if (!this.case) return false; // No case available

    const currentUser = this.userService.currentUser;
    if (!currentUser) return false; // No current user available

    const role = currentUser.role;
    if (!role) return false; // No role available for current user
    if (this.case.status !== 'initial') return false; // Case must be in initial status
    const canCreateCases = role.createCases;
    const hasRequiredUnit = role.units.some(
      (unit) => unit.code === 'AN' || unit.code === 'ALT',
    );
    //

    return canCreateCases && hasRequiredUnit; // Check all conditions
  }

  get canRejectAssignament() {
    if (!this.case) return false;
    if (!this.case.assigned) return false;
    const statusDeDesicion =
      this.case.status == 'assigned' || this.case.status == 'running';
    const esAnalistaDesignado =
      this.userService.currentUser?._id == this.case?.assigned._id;
    if (esAnalistaDesignado && statusDeDesicion) return true;
  }

  get cantipifi() {
    if (!this.alert) return false;
    return (
      this.userService.permissions.editCases &&
      this.alert?.assigned == undefined &&
      this.alert?.reason == undefined
    );
  }

  get canEdit() {
    return this.userService.permissions?.editCases;
  }
  get isNot3() {
    return this.alert?.code != '03';
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log('Changes detected:', changes);

    if (changes.alert && !this.case && this.alert) {
      this.getNumberStatus(this.alert.status);
    } else if (changes.case && this.case) {
      this.getNumberStatus(this.case.status);
    }
  }

  ngOnInit() {
    this.loadHeaderImage();
    // puedeCrearCasos
    this.hasCreateCasesPermission =
      this.userService.currentUser.role?.createCases;
  }

  loadHeaderImage() {
    this.http
      .get('assets/images/encabezado.png', { responseType: 'blob' })
      .subscribe((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.encabezadoBase64 = reader.result?.toString().split(',')[1] || '';
        };
        reader.readAsDataURL(blob);
      });
  }

  stepperChange() {
    const stepHeaders =
      this.el.nativeElement.querySelectorAll('mat-step-header');
    const lines = this.el.nativeElement.querySelectorAll(
      '.mat-stepper-horizontal-line',
    );
    const headers = this.el.nativeElement.querySelectorAll(
      '.mat-horizontal-stepper-header',
    );

    stepHeaders.forEach((stepHeader, index) => {
      const iconElement = stepHeader.querySelector(
        '.mat-step-icon.mat-step-icon-state-number',
      );
      if (!iconElement) return;

      const isCurrent = this.statusNumber === index;
      const isFuture = this.statusNumber < index;
      const isPast = this.statusNumber > index;

      if (isCurrent) {
        this.renderer.setStyle(iconElement, 'background-color', '#2196f3');
        this.renderer.setStyle(iconElement, 'color', 'rgb(255 255 255)');
        this.renderer.removeStyle(iconElement, 'border');
      } else if (isFuture) {
        this.renderer.setStyle(
          iconElement,
          'background-color',
          'rgb(255 255 255)',
        );
        this.renderer.setStyle(iconElement, 'border', 'solid 2px #dcdcdc');
        this.renderer.setStyle(iconElement, 'color', 'inherit');
      } else if (isPast) {
        this.renderer.setStyle(
          iconElement,
          'background-color',
          'rgb(255 255 255)',
        );
        this.renderer.setStyle(iconElement, 'color', '#767676');
        this.renderer.removeStyle(iconElement, 'border');
      }
    });

    // lines.forEach((line, index) => {
    //   const isPast = this.statusNumber - 1 >= index;
    //   this.renderer.setStyle(line, 'top', '39px');
    //   this.renderer.removeClass(line, isPast ? 'lineGrey' : 'lineBlue');
    //   this.renderer.addClass(line, isPast ? 'lineBlue' : 'lineGrey');
    // });

    // headers.forEach((header, index) => {
    //   const isPast = this.statusNumber - 1 >= index;
    //   this.renderer.removeClass(header, isPast ? 'lineGrey' : 'lineBlue');
    //   this.renderer.addClass(header, isPast ? 'lineBlue' : 'lineGrey');
    // });

    lines.forEach((line, index) => {
      // ❌ Protección: no exceder la cantidad de líneas
      if (index >= lines.length) return;

      const isPast = this.statusNumber - 1 >= index;
      this.renderer.setStyle(line, 'top', '39px'); // centra verticalmente
      this.renderer.removeClass(line, isPast ? 'lineGrey' : 'lineBlue');
      this.renderer.addClass(line, isPast ? 'lineBlue' : 'lineGrey');
    });

    headers.forEach((header, index) => {
      // ❌ No tocar el último header
      if (index === headers.length - 1) return;

      const isPast = this.statusNumber - 1 >= index;
      this.renderer.removeClass(header, isPast ? 'lineGrey' : 'lineBlue');
      this.renderer.addClass(header, isPast ? 'lineBlue' : 'lineGrey');
    });
  }

  getNumberStatus(status: string): void {
    const statusMap: Record<string, number> = {
      initial: 0,
      assigned: 1,
      running: 2,
      tobeApproved: 3,
      // rejected: 4,
      toFinalize: 4,
      finalized: 4,
    };

    if (status === 'rejected') {
      this.statusNumber = 2;
    } else {
      this.statusNumber = statusMap[status] ?? 0;
    }

    this.stepperChange();
  }

  rejectAssignament() {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title: '¿Deseas aprobar rechazar asignación de alerta?',
          type: null,
          approbvalStatus: this.case.approvalStatus,
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          const response = (await this.getComment()) as string;
          if (response == undefined) {
            return this.showMessageSucess('Debe agregar comentario');
          }
          this.caseService
            .rejectCaseAssignament(this.case._id, { comment: response })
            .subscribe({
              next: () => {
                this.headerMessage.emit('reload');
                this.showMessageSucess('A rechazado asignación');
                window.history.go(-1);
              },
            });
        }
      });
  }
  async getComment() {
    const classGetComment = {
      width: '90vw',
      maxWidth: '800px',
      maxHeight: '95vh',
      disableClose: true,
      panelClass: 'modalVerTarea',
    };
    return new Promise((resolve) => {
      const ref = this.dialog.open(
        ComentarioSolicitarRevisionComponent,
        classGetComment,
      );
      ref.afterClosed().subscribe((response) => {
        resolve(response);
      });
    });
  }
  approval() {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title: '¿Deseas aprobar esta alerta?',
          type: null,
          approbvalStatus: this.case.approvalStatus,
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          this.caseService.acceptApproval(this.case._id).subscribe({
            next: async () => {
              this.headerMessage.emit('isLoadingTrue');
              this.headerMessage.emit('getInformation');
              this.headerMessage.emit('reload');
              this.showMessageSucess('La alerta ha sido aprobada');
              this.caseRecordService.updatedRecord.next(true);

              console.log(
                '%c[APPROVAL] Case Type:',
                'color: #1976d2; font-weight: bold;',
                this.case.caseType,
              );

              const remitInstructions = this.case.caseType.remitTo;
              const shouldRemit =
                remitInstructions &&
                remitInstructions.some(
                  (instruction) => instruction.remitIf === 'approved',
                );

              if (shouldRemit) {
                console.log(
                  '%c[APPROVAL] Remitting case due to "approved" instruction found.',
                  'color: #388e3c; font-weight: bold;',
                );
                this.remitTo(this.case._id);
                return;
              }

              if (this.case.alert) {
                const alert = this.case.alert;
                if (alert.status !== 'refusedApproved') {
                  const isSpecialCode =
                    alert.code === '04' ||
                    alert.code === '05' ||
                    alert.code === '02';
                  if (isSpecialCode) {
                    console.log(
                      `%c[APPROVAL] 🚀 Remitting to Casos Sin Asignar...`,
                      'color: #ff9800; font-weight: bold;',
                    );
                    await this.caseService
                      .remitToCasosSinAsignar(
                        this.case._id,
                        this.userService.currentUser._id,
                      )
                      .toPromise();
                    console.log(
                      '%c[APPROVAL] ✅ Finished remitToCasosSinAsignar.',
                      'color: #388e3c; font-weight: bold;',
                    );
                    this.showMessageSucess(
                      'Alerta remitida exitosamente a Casos Sin Asignar.',
                    );
                  } else {
                    console.log(
                      `%c[APPROVAL] ⚠️ Skipping remitToCasosSinAsignar: Not a special code`,
                      'color: #f44336; font-weight: bold;',
                    );
                  }
                } else {
                  console.log(
                    `%c[APPROVAL] ⛔ Alert status is 'refusedApproved', skipping remit.`,
                    'color: #b71c1c; font-weight: bold;',
                  );
                }
              } else {
                console.log(
                  '%c[APPROVAL] No alert object found on case.',
                  'color: #bdbdbd; font-style: italic;',
                );
              }
            },
          });
        }
      });
  }

  async reject() {
    const response = (await this.getComment()) as string;
    if (response) {
      this.caseService
        .rejectApproval(this.case._id, {
          comment: response,
        })
        .subscribe({
          next: () => {
            this.headerMessage.emit('getInformation');
            this.headerMessage.emit('reload');
            this.showMessageSucess('La Alerta ha sido devuelta');
            this.caseRecordService.updatedRecord.next(true);
          },
        });
      return;
    }
  }

  async edit(idCase) {
    const caseData = await this.getCaso(idCase);

    const dialogRef = this.dialog.open(CreateAlertComponent, {
      data: {
        unit: caseData.caseType.unit,
        case: caseData,
      },
      disableClose: true,
      width: '700px',
      maxHeight: '80vh',
    });
    dialogRef.afterClosed().subscribe(async () => {
      this.headerMessage.emit('getInformation');
      this.caseRecordService.updatedRecord.next(true);
    });
  }

  tipificar() {
    this.dialog
      .open(ProceedCaseComponent, {
        width: '700px',
        maxHeight: '80vh',
        data: {
          alert: this.alert,
        },
        panelClass: 'class-ras-create',
      })
      .afterClosed()
      .subscribe({
        next: async (alert: any) => {
          if (alert.updated) {
            this.alert = alert.alert;
            this.alertRecordService.updatedRecord.next(true);
            this.proceedAlert.emit(alert.case._id);
          }
        },
      });
  }
  showMessageSucess(title) {
    this.dialog.open(SuccessComponent, {
      data: {
        title,
      },
      minWidth: '300px',
    });
  }
  async remitTo(idCase: string) {
    const caseData: any = await this.getCaso(idCase);

    if (!caseData.caseType.remitTo || caseData.caseType.remitTo.length === 0) {
      console.error(
        'remitTo fue llamado, pero no se encontraron instrucciones de remisión.',
      );
      return;
    }

    const approvedDestinations = caseData.caseType.remitTo.filter(
      (instruction) => instruction.remitIf === 'approved',
    );

    if (approvedDestinations.length === 0) {
      console.warn(
        "remitTo fue llamado, pero ninguna instrucción coincidía con 'approved'.",
      );
      return;
    }

    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: {
          case: caseData,
          destinations: approvedDestinations,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (remittalSucceeded: boolean) => {
          if (remittalSucceeded) {
            this.generateTasks();
          }
        },
      });
  }
  generateTasks() {
    if (this.case.caseType.generateTasks.length > 0) {
      this.dialog.open(GenerateTasksComponent, {
        width: '900px',
        maxHeight: '80vh',
        data: {
          case: this.case._id,
          caseType: this.case.caseType._id,
        },
        disableClose: true,
      });
    }
  }

  async getCaso(caseId = undefined) {
    // const id = this.route.snapshot.paramMap.get('id');
    const icase = await this.caseService
      .getCase(caseId)
      .pipe(first())
      .toPromise();
    this.case = icase;
    this.getNumberStatus(this.case.status);

    return icase;
  }
  assign() {
    const dialogRef = this.dialog.open(AssignmentModalComponent, {
      width: '450px',
      data: { case: this.case },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.headerMessage.emit('getInformation');
    });
  }
  openRecord() {
    if (this.case) {
      this.headerMessage.emit('openRecord');
    } else {
      this.headerMessage.emit('openRecordAlert');
    }
  }

  // codigo para generar pdf by GA

  async generatePDF() {
    this.isLoading = true; // Mostrar spinner
    try {
      if (!this.case) {
        console.error('No case data available to generate the PDF.');
        return;
      }

      const docDefinition = await this.generateDocDefinition();

      pdfMake.createPdf(docDefinition).download(`alerta.pdf`);
    } catch (error) {
      console.error('Error generando el PDF:', error);
    } finally {
      this.isLoading = false; // Ocultar spinner
    }
  }
  async generatePDFPreviewPage() {
    // this.route.navigate([`ReportFileComponent/${this.case._id}`]);

    if (!this.case || !this.case._id) {
      this.snackBar.open('No hay caso para previsualizar.', 'X', {
        duration: 2000,
      });
      return;
    }
    // Abre una nueva pestaña con la ruta deseada
    window.open(`/#/ReportFileComponent/${this.case._id}`, '_blank');
  }
  // Previsualizacion del pdf
  async generatePDFPreview() {
    this.isLoading = true; // Mostrar spinner
    try {
      if (!this.case) {
        console.error('No case data available to generate the PDF.');
        return;
      }
      const docDefinition = await this.generateDocDefinition();
      // console.log(docDefinition);

      await new Promise((resolve, reject) => {
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          const url = URL.createObjectURL(blob);
          // console.log(url);
          window.open(url, '_blank'); // Abrir en una nueva ventana
          resolve(url);
        });
      });

      this.snackBar.open(
        'Si aun no se visualiza el archivo es porque supero el límite de tamaño, intente descargarlo',
        'X',
        { duration: 2000 },
      );

      // pdfMake.createPdf(docDefinition).download(`reporte_caso.pdf`);
    } catch (error) {
      console.error('Error al generar o abrir el PDF:', error);
      // Puedes agregar lógica para mostrar un mensaje al usuario si lo deseas
      alert('Hubo un error al generar el PDF. Por favor intentalo nuevamente.');
    } finally {
      this.isLoading = false; // Ocultar spinner
    }
  }

  async generateDocDefinition() {
    // const images = await this.caseFilesService.getAllCaseFile(this.case._id).toPromise();
    // console.log(images);
    const files = await this.caseFilesService
      .getAllCaseFile(this.case._id)
      .toPromise();
    // console.log(files);
    // Lista de extensiones válidas
    const validExtensions = ['.jpg', '.jpeg', '.png'];

    // Filtrar imágenes válidas basadas en la propiedad "name"
    const validImageFiles = files.filter((file) => {
      const extension = file.name.split('.').pop()?.toLowerCase();
      return validExtensions.includes(`.${extension}`);
    });

    // console.log('Archivos válidos:', validImageFiles);

    // Procesar imágenes con un pequeño retraso entre cada una
    const validImages: { base64: string; fileName: string }[] = [];
    for (const file of validImageFiles) {
      try {
        const base64 = await new Promise<string>(async (resolve) => {
          resolve(await this.getBase64ImageFromURL(file.url));
        });
        validImages.push({ base64, fileName: file.name });
      } catch (error) {
        console.error('Error al procesar la imagen:', file.url, error);
      }
    }

    // console.log('Imágenes procesadas:', validImages);

    const datosCliente = this.case.additionalInformation;
    const datosCaso = this.case;
    const contactos = await this.callContactService
      .getCallContacts(this.case._id)
      .toPromise();
    // console.log(contactos);

    const statusMap = {
      successful: 'exitoso',
      unsuccessful: 'No exitoso',
      pending: 'Pendiente',
    };

    const comments = await this.caseCommentService
      .getCommentsByCase(this.case._id)
      .toPromise();

    let estadoAlert = datosCaso?.status;
    if (estadoAlert == 'toFinalize') estadoAlert = 'Finalizado';
    if (estadoAlert == 'finalized') estadoAlert = 'Finalizado';

    if (contactos.length === 0) {
      console.log('No hay contactos disponibles.');
    }

    const imageBase64 = await this.getImageBase64(
      'assets/images/header_expediente.png',
    );
    const imageBase64Footer = await this.getImageBase64(
      'assets/images/footer.png',
    );
    const numeroAlerta = this.case?.gai || 'N/A';

    const contactosFilas = contactos.map((contact) => [
      contact?.name || 'N/A',
      contact.description || 'N/A',
      contact.result || 'N/A',
      contact.createdAt ? new Date(contact.createdAt).toLocaleString() : 'N/A',
      contact.closeDate ? new Date(contact.closeDate).toLocaleString() : 'N/A',
      statusMap[contact.status] || 'N/A',
    ]);
    const contactosContent =
      contactos.length > 0
        ? [
            {
              table: {
                widths: [
                  '16,66%',
                  '16,66%',
                  '16,66%',
                  '16,66%',
                  '16,66%',
                  '16,66%',
                ], // Ajusta los anchos
                body: [
                  // Cabeceras de la tabla
                  [
                    { text: 'Nombre Contacto', style: 'tableHeader' },
                    { text: 'Descripción', style: 'tableHeader' },
                    { text: 'Resultado', style: 'tableHeader' },
                    { text: 'Creado', style: 'tableHeader' },
                    { text: 'Fecha de Cierre', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' },
                  ],
                  // Filas con datos
                  ...contactosFilas,
                ],
              },
              layout: {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => '#CCCCCC',
                vLineColor: () => '#CCCCCC',
                paddingLeft: () => 8,
                paddingRight: () => 8,
                paddingTop: () => 6,
                paddingBottom: () => 6,
              },
              margin: [0, 10, 0, 20],
              pageBreak: 'after',
            },
          ]
        : [
            {
              text: '¡Tu historial de contacto está vacío!',
              alignment: 'center',
              margin: [0, 10, 0, 20],
              pageBreak: 'after',
            },
          ];

    const docDefinition = {
      content: [
        // Encabezado con imagen
        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        // Título
        {
          text: `Expediente de alerta ${numeroAlerta || 'N/A'}`,
          style: 'title',
        },
        // Tabla 1: Datos del Cliente
        {
          table: {
            widths: ['50%', '50%'],
            body: [
              [
                { text: 'Tipo de Persona:', style: 'tableHeader' },
                {
                  text: datosCliente?.tipo_de_persona || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Nombre Completo:', style: 'tableHeader' },
                {
                  text:
                    `${datosCliente?.nombre || ''} ${
                      datosCliente?.apellido || ''
                    }` || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Oficina/Agencia:', style: 'tableHeader' },
                { text: datosCliente?.oficina || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Teléfono:', style: 'tableHeader' },
                { text: datosCliente.telefono || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Celular:', style: 'tableHeader' },
                { text: datosCliente?.celular || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Domicilio del Cliente:', style: 'tableHeader' },
                { text: datosCliente.domicilio || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'CI/RIF:', style: 'tableHeader' },
                {
                  text: datosCliente?.numero_de_identificacion || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Región:', style: 'tableHeader' },
                { text: datosCliente.region || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Correo Electrónico:', style: 'tableHeader' },
                { text: datosCliente.correo || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Cliente:', style: 'tableHeader' },
                { text: datosCliente?.cliente || 'N/A', style: 'tableData' },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#CCCCCC',
            vLineColor: () => '#CCCCCC',
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6,
          },
          margin: [0, 10, 0, 10],
          pageBreak: 'after',
        },

        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Datos del Caso:',
          style: 'title',
        },
        {
          table: {
            widths: ['50%', '50%'],
            body: [
              [
                { text: 'Número de la Alerta:', style: 'tableHeader' },
                { text: datosCaso?.gai || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Tipo de Registro:', style: 'tableHeader' },
                {
                  text:
                    datosCaso?.additionalInformation?.tipo_registro || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Descripción de la Alerta:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.oficina || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                {
                  text: 'Datos del Instrumento Financiero:',
                  style: 'tableHeader',
                },
                {
                  text: datosCaso?.additionalInformation?.instrumento || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'ID Gerente Responsable:', style: 'tableHeader' },
                { text: '//Cambiar', style: 'tableData' },
              ],
              [
                { text: 'Categoría:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.category || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'SubTipo:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.subType || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Analista Responsable:', style: 'tableHeader' },
                {
                  text: datosCaso?.assigned?.fullname || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Estado del Alerta:', style: 'tableHeader' },
                { text: estadoAlert || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Fecha de Creación:', style: 'tableHeader' },
                { text: datosCaso?.createdAt || 'N/A', style: 'tableData' },
              ],

              [
                { text: 'Canal:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.canal || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Gerente responsable:', style: 'tableHeader' },
                {
                  text:
                    datosCaso?.additionalInformation?.userTipify?.fullname ||
                    datosCaso?.additionalInformation?.creator?.fullname,
                  style: 'tableData',
                },
              ],
              [
                { text: 'Monto de la Transacción:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.monto_salio || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Comentario de Aprobación:', style: 'tableHeader' },
                { text: datosCaso?.commentReview || 'N/A', style: 'tableData' },
              ],
              [
                { text: 'Tipo:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.type || 'N/A',
                  style: 'tableData',
                },
              ],
              [
                { text: 'Prioridad:', style: 'tableHeader' },
                {
                  text: datosCaso?.additionalInformation?.priority || 'N/A',
                  style: 'tableData',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#CCCCCC',
            vLineColor: () => '#CCCCCC',
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6,
          },
          margin: [0, 10, 0, 10],
          pageBreak: 'after',
        },
        // PAGINA 3

        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Historial de Contactos:',
          style: 'title',
        },
        ...contactosContent,

        // Página 4: Archivos png

        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Archivos:',
          style: 'title',
        },
        ...(validImages.length > 0
          ? validImages.map((image, index) => ({
              stack: [
                {
                  text: `Archivo ${index + 1}: ${image.fileName}`,
                  style: 'header',
                },
                {
                  image: image.base64,
                  width: 500,
                  margin: [0, 10, 0, 10],
                  alignment: 'center',
                },
              ],
              pageBreak: 'after',
            }))
          : [
              {
                stack: [
                  {
                    text: '¡No hay imágenes válidas para mostrar!',
                    alignment: 'center',
                  },
                ],
                pageBreak: 'after',
              },
            ]),

        // Página 5: Grafo
        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Immersion Skuld:',
          style: 'title',
        },
        this.grafoImageUrl
          ? {
              image: this.grafoImageUrl,
              width: 500,
              height: 300,
              alignment: 'center',
              margin: [0, 10, 0, 10],
              pageBreak: 'after', // Salto de página aquí
            }
          : {
              text: '¡No hay una imagen de Immersion para mostrar!',
              alignment: 'center',
              margin: [0, 10, 0, 10],
              pageBreak: 'after', // Salto de página aquí
            },

        // Página 6: Timeline
        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Timeline:',
          style: 'title',
        },
        {
          stack: [
            {
              ul: this.case.timeline?.map(
                (event) => `${event.date}: ${event.description}`,
              ) || ['No hay eventos registrados en el timeline.'],
            },
          ],
          pageBreak: 'after',
        },

        // Página 7: Comentarios
        {
          image: imageBase64, // Tu imagen en base64
          width: 595.28, // Ancho completo de una página A4 en puntos (72 puntos por pulgada)
          alignment: 'center', // Centrar horizontalmente
          margin: [0, -40, 0, 10], // Margen inferior para el espacio después del encabezado
        },
        {
          text: 'Comentarios:',
          style: 'title',
        },
        {
          stack: [
            {
              ul:
                Array.isArray(comments) && comments.length > 0
                  ? comments.map(
                      (comment) =>
                        `${comment.user.fullname}: ${
                          comment.comment
                        } - ${new Date(comment.createdAt).toLocaleString()}`,
                    )
                  : ['No hay comentarios disponibles.'],
              style: 'listStyle',
            },
          ],
        },
      ],
      footer: (currentPage, pageCount) => {
        return {
          columns: [
            {
              image: imageBase64Footer, // Imagen del footer en base64
              width: 595.28, // Ancho de página A4
              alignment: 'center',
            },
          ],
          margin: [0, -20, 0, 0], // Ajustar margen inferior
        };
      },
      styles: {
        title: {
          fontSize: 24,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 20],
          color: '#002855',
        },
        tableHeader: {
          bold: true,
          italic: true,
          fontSize: 14,
          alignment: 'left',
          color: '#202e63',
        },
        tableData: {
          fontSize: 14,
          alignment: 'left',
          color: '#002855',
        },
        listStyle: {
          fontSize: 14, // Coincide con tableData
          alignment: 'left',
          color: '#333333',
          margin: [0, 6, 0, 6], // Espaciado entre líneas
        },
      },
      defaultStyle: {
        font: 'Roboto',
      },
    };

    // Validaciones de datos
    if (!datosCliente || typeof datosCliente !== 'object') {
      console.error(
        'datosCliente no está definido o es inválido:',
        datosCliente,
      );
    }
    if (!datosCaso || typeof datosCaso !== 'object') {
      console.error('datosCaso no está definido o es inválido:', datosCaso);
    }

    return docDefinition;
  }

  async getBase64ImageFromURL(url: string): Promise<string> {
    try {
      const img = await this.loadImage(url);
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');
      return dataURL;
    } catch (error) {
      console.error('Error al cargar la imagen:', error);
      throw error;
    }
  }
  getImageBase64(path: string): Promise<string> {
    return this.http
      .get(path, { responseType: 'blob' })
      .toPromise()
      .then((blob) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(blob);
        });
      });
  }

  // Función para cargar la imagen de manera asíncrona
  loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous'); // Permitir cargar imágenes desde otros dominios

      img.onload = () => resolve(img); // Resolvemos cuando la imagen se haya cargado
      img.onerror = () =>
        reject(new Error(`No se pudo cargar la imagen desde la URL: ${url}`)); // Rechazamos si hay error

      img.src = url; // Iniciamos la carga de la imagen
    });
  }

  logCaseProperties() {}
}
